<template>
  <div class="main-body">
    <div class="item-list">
      <div class="echart-list">
        <template>
          <slot name="top"></slot>
        </template>
        <template>
          <div class="item-list-left"></div>
          <div class="item-list-right"></div>
          <slot name="left-right">
          </slot>
        </template>
        <template>
          <div class="item-list-two"></div>
          <div class="item-list-one"></div>
          <slot name="left-right">
          </slot>
        </template>
      </div>
    </div>
    <div class="data-list">
      <template>
        <slot name="main"></slot>
      </template>
    </div>
  </div>
</template>
<script>
  export default {
    name: "UdPanel",
    props:['title'],
    mounted(){}
  }
</script>


// WEBPACK FOOTER //
// src/components/panel/UdPanel.vue